export class LoadAnalysisCodesAction {
  static type = '[AnalysisCodes] LoadAnalysisCodesAction';
}

import { AnalysisCodesByLaboratory } from '@core/core.types';

export class SetAnalysisCodesAction {
  static type = '[AnalysisCodes] SetAnalysisCodesAction';
  constructor(public codesByLaboratory: AnalysisCodesByLaboratory) {}
}
